module.exports = __webpack_public_path__ + "img/left-arrow-white.b683f181.svg";